import NewsletterBanner from './NewsletterBanner';

export default function NewsletterBannerWide() {
  return <NewsletterBanner variant="wide" />;
}
